// extracted by mini-css-extract-plugin
export var defaultWrapper = "_nq-3";
export var downloadButton = "_nq-4";
export var fileContainer = "_nq-9 _nq-7";
export var fileContainerBase = "_nq-7";
export var fileContainerFixedHeight = "_nq-8 _nq-7";
export var fileInfo = "_nq-5";
export var fileInfoWidthRestricted = "_nq-6";
export var fileType = "_nq-1";
export var fileTypeName = "_nq-2";
export var image = "_nq-0";
export var link = "_nq-b";
export var overflowEllipsis = "_nq-a";